<template>
  <div v-if="value" v-bsl="value"></div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import moment from 'moment';

import TeacherSvg from '@/assets/images/onboarding/classlist.svg';
import ArrowBottomSvg from '@/assets/images/onboarding/arrowbottom.svg';

export default {
  name: 'HomeworkDesktop',
  props: {
    value: {
      required: true,
    },
  },
  computed: {
    ...mapState('students', ['student']),

    teacherImage() {
      return TeacherSvg;
    },

    arrowRightImage() {
      return ArrowBottomSvg;
    },

    onboardingStepText() {
      return `
        <div class="flex flex-col justify-center items-center">
          <img style="max-width: 155px" src="${this.teacherImage}"/>
          <h3 class="text-center">${this.$t('onboarding.homework.title')}</h3>
          <p class="text-center py-4 px-8">${this.$t('onboarding.homework.content')}</p>
        </div>`;
    },
  },
  methods: {
    ...mapMutations('layout', ['showClassList', 'hideClassList']),
    ...mapActions('onboarding', ['setOnboardingProperty']),

    closeOnboardingTag() {
    },

    acceptOnboardingTag() {
    },

    getDateWithYearlyOffset(years) {
      return moment().add(years, 'y').toDate();
    },

    addArrow(tour) {
      const currentStepElement = tour.currentStep.el;
      const header = currentStepElement.querySelector('.shepherd-header');
      const progress = document.createElement('img');
      progress.classList.add('stepherd-custom-arrow--left');
      progress.src = `${this.arrowRightImage}`;
      header.insertBefore(
        progress,
        currentStepElement.querySelector('.shepherd-cancel-icon'),
      );
    },

    startOnboarding() {
      this.$nextTick(() => {
        const vm = this;
        const tour = this.$shepherd({
          useModalOverlay: true,
          defaultStepOptions: {
            cancelIcon: {
              enabled: true,
            },
          },
        });

        tour.addStep({
          text: vm.onboardingStepText,
          beforeShowPromise() {
            return new Promise((resolve) => {
              setTimeout(() => {
                window.scrollTo(0, 0);
                resolve();
              }, 500);
            });
          },
          attachTo: {
            element: '.taskdetails__box',
            on: 'left-start',
          },
          canClickTarget: false,
          modalOverlayOpeningRadius: 12,
          popperOptions: {
            placement: 'left-start',
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 20],
                },
              },
            ],
          },
          buttons: [
            {
              text: this.$t('onboarding.homework.btn'),
              action() {
                vm.acceptOnboardingTag();
                vm.$emit('input', !vm.value);
                vm.setTourCookie();
                return this.cancel();
              },
            },
          ],
          when: {
            show() {
              vm.addArrow(this.tour);
            },
            cancel() {
              vm.closeOnboardingTag();
              vm.$emit('input', !vm.value);
              vm.setTourCookie();
            },
          },
        });

        tour.start();

        Event.$on('cancelTour', () => {
          tour.cancel();
        });
      });
    },

    setTourCookie() {
      if (this.student?.id) {
        this.setOnboardingProperty({ deviceType: 'desktop', property: 'singleHomework', value: true });
      }
    },
  },

  beforeDestroy() {
    Event.$off('cancelTour');
  },

  watch: {
    value(value) {
      if (value) {
        this.startOnboarding();
      }
    },
  },
};
</script>
